
import { computed, defineComponent } from "vue";

export default defineComponent({
  name: "lux-avatar",
  props: {
    size: { type: Number, default: 40 },
    thinking: { type: Boolean, default: false },
  },
  setup(props) {
    // Dois arquivos, não um redimensionado: o de 64 fica nítido no chat e o de
    // 256 no cabeçalho.
    const src = computed(() =>
      props.size > 64 ? "/media/lux/lux_256.png" : "/media/lux/lux_64.png"
    );

    const sizeStyle = computed(() => ({
      width: `${props.size}px`,
      height: `${props.size}px`,
    }));

    return { src, sizeStyle };
  },
});
